import createReducer from 'Lib/createReducer';

export const SAVE_TITLE = 'SAVE_TITLE';


const initialState = '';

const actionHandlers = {
  [SAVE_TITLE]: (state, action) => {
    return action.title;
  }
};


export default createReducer(initialState, actionHandlers);
